/* eslint-disable semi */
/* eslint-disable react/prop-types */
import React, { Component } from 'react';
import { list, unbind_merchat_id } from '../../store/linking/actions';
import { safeGet } from 'iotera-base/utility/json';
import toastr from 'toastr';
import 'toastr/build/toastr.min.css';
import { connect } from 'react-redux';
import MetaTags from 'react-meta-tags';
import { buildTitle, NAVBAR } from 'Apps';
import { Card, CardBody, Col, Container, Row } from 'reactstrap';
import paginationFactory, {
  PaginationListStandalone,
  PaginationProvider,
} from 'react-bootstrap-table2-paginator';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import BootstrapTable from 'react-bootstrap-table-next';
import Result from 'iotera-base/result';
import Pages403 from '../pages-403';
import SweetAlert from 'react-bootstrap-sweetalert';

class ListLinking extends Component {
  constructor(props) {
    super(props);
    this.node = React.createRef();
    this.state = {
      list_binding: [],
      isUnlinking: false,
      success_dlg: false,
      loadingCommand: false,
      succes_clear: true,
      error_dlg: false,
      dynamic_title: '',
      device_id: '',
      currentPage: 1,
      row: {},
      searchText: '',
      column: [
        {
          dataField: 'id',
          text: 'id',
          hidden: 'true',
          editable: false,
          formatter: (cell, row) => {
            return <>{row.id}</>;
          },
        },

        {
          dataField: 'device_name',
          text: 'Device Name',
          formatter: (cellContent, row) => (
            <>
              <p
                style={{ fontWeight: 'bold', textDecorationLine: 'underline' }}
                className="mb-1"
              >
                {safeGet(row, 'device_name', '-')}
              </p>
              <p className="mb-1">{safeGet(row, 'device_id', '-')}</p>
            </>
          ),
        },
        {
          dataField: 'bind_name',
          text: 'Bind Name',
          formatter: (cellContent, row) => (
            <>
              <p
                style={{ fontWeight: 'bold', textDecorationLine: 'underline' }}
                className="mb-1"
              >
                {safeGet(row, 'bind_name', '-')}
              </p>
              <p className="mb-1">{safeGet(row, 'bind_id', '-')}</p>
            </>
          ),
        },
        {
          dataField: 'is_binding',
          text: 'Is Binding',
          formatter: (cellContent, row) => (
            <>
              <p>
                <button
                  style={{ border: 'none' }}
                  className={
                    'font-size-12 badge-soft-' +
                    (row.is_binding ? 'success' : 'danger')
                  }
                  color={row.is_binding ? 'success' : 'danger'}
                >
                  {safeGet(row, 'is_binding') ? 'Binding' : 'No Binding'}
                </button>
              </p>
            </>
          ),
        },
        {
          dataField: 'action',
          text: 'Action',
          isDummyData: true,
          formatter: (cellContent, row) => (
            <>
              {row.is_binding ? (
                <button
                  type="button"
                  color="danger"
                  className="btn btn-sm btn-rounded btn-danger"
                  onClick={() => this.handleUnlinking(row)}
                >
                  Unlinking
                </button>
              ) : (
                <></>
              )}
            </>
          ),
        },
      ],
    };
    this.handleUnlinking = this.handleUnlinking.bind(this);
    this.handleUnlinkingSubmit = this.handleUnlinkingSubmit.bind(this);
  }
  componentDidMount() {
    this.props.List();
  }

  componentDidUpdate(prevProps) {
    if (this.props.listResult !== prevProps.listResult) {
      const code = safeGet(this.props, ['listResult', 'code'], Result.FAILED);
      if (code == Result.SUCCESS) {
        const body = safeGet(this.props, ['listResult', 'body'], []);
        this.setState({
          list_binding: body,
        });
      }
    }

    if (this.props.unLinkResult !== prevProps.unLinkResult) {
      const body = safeGet(this.props, 'unLinkResult', {});
      const code = safeGet(body, 'code', Result.FAILED);
      if (code == Result.SUCCESS) {
        this.componentDidMount();
        this.showToast('Success UnLink', 'success');
      } else if (code == Result.FAILED) {
        const message = safeGet(body, 'message', '');
        this.showToast(message, 'error');
      }
    }
  }

  showToast(msg, toastType) {
    toastr.options = {
      closeButton: false,
      debug: false,
      newestOnTop: false,
      progressBar: true,
      positionClass: 'toast-top-right',
      preventDuplicates: false,
      onclick: null,
      showDuration: '300',
      hideDuration: '1000',
      timeOut: '5000',
      extendedTimeOut: '1000',
      showEasing: 'swing',
      hideEasing: 'linear',
      showMethod: 'fadeIn',
      hideMethod: 'fadeOut',
    };

    if (toastType === 'info') toastr.info(msg);
    else if (toastType === 'warning') toastr.warning(msg);
    else if (toastType === 'error') toastr.error(msg);
    else toastr.success(msg);
  }
  handleUnlinking = row => {
    this.setState({
      isUnlinking: true,
      row: row,
    });
  };
  handleUnlinkingSubmit = row => {
    this.setState({
      isUnlinking: false,
      success_dlg: true,
      dynamic_title: 'Unlinking',
      dynamic_description: 'Unlinking has been Sent.',
    });
    this.props.UnlinkMerchant(row);
  };
  handlePageChange = page => {
    this.setState({ currentPage: page });
  };

  handleSearchChange = () => {
    this.setState({
      currentPage: 1,
    });
  };

  render() {
    const { list_binding, column, currentPage } = this.state;
    const { SearchBar } = Search;
    const pageOptions = {
      sizePerPage: 100,
      page: currentPage,
      totalSize: list_binding.length,
      onPageChange: this.handlePageChange,
      custom: true,
    };

    const defaultSorted = [
      {
        dataField: 'id',
        order: 'desc',
      },
    ];
    if (safeGet(NAVBAR, ['Bind Merchant', 'view'], 'off') == 'off') {
      return (
        <React.Fragment>
          <style>
            {`
            @keyframes blink {
              0% { opacity: 1; }
              50% { opacity: 0; }
              100% { opacity: 1; }
            }
      
            .blinking {
              animation: blink 2s infinite;
            }
      
            .center-screen {
              display: flex;
              justify-content: center;
              align-items: center;
              flex-direction: column;
              height: 100vh;
              width: 100vw;
              text-align: center;
            }
          `}
          </style>
          <Pages403 className="center-screen" />
        </React.Fragment>
      );
    }
    return (
      <React.Fragment>
        <div className="page-content">
          <MetaTags>
            <title>{buildTitle('List Device LInking')}</title>
          </MetaTags>
          <Container>
            {this.state.isUnlinking ? (
              <SweetAlert
                title="Are you sure?"
                warning
                showCancel
                confirmButtonText="Yes, Unlinking it!"
                confirmBtnBsStyle="success"
                cancelBtnBsStyle="danger"
                onConfirm={() => this.handleUnlinkingSubmit(this.state.row)}
                onCancel={() =>
                  this.setState({
                    isUnlinking: false,
                  })
                }
              >
                You won&apos;t be able to revert this!
              </SweetAlert>
            ) : null}
            {this.state.success_dlg ? (
              this.state.succes_clear ? (
                <SweetAlert
                  success
                  title={this.state.dynamic_title}
                  onConfirm={() => {
                    this.props.List();
                    this.setState({ success_dlg: false });
                  }}
                >
                  {this.state.dynamic_description}
                </SweetAlert>
              ) : (
                <SweetAlert
                  danger
                  title={this.state.dynamic_title}
                  onConfirm={() => {
                    setTimeout(() => {
                      this.props.List();
                    }, 2000);
                    this.setState({ success_dlg: false });
                  }}
                >
                  {this.state.dynamic_description}
                </SweetAlert>
              )
            ) : null}
            <Row>
              <Col lg="12">
                <Card>
                  <CardBody>
                    <PaginationProvider
                      pagination={paginationFactory(pageOptions)}
                      keyField="id"
                      columns={column}
                      data={list_binding}
                    >
                      {({ paginationProps, paginationTableProps }) => (
                        <ToolkitProvider
                          keyField="id"
                          columns={column}
                          data={list_binding}
                          search
                        >
                          {toolkitprops => (
                            <React.Fragment>
                              <Row className="mb-2">
                                <Col sm="4">
                                  <div className="search-box ms-2 mb-2 d-inline-block">
                                    <div className="position-relative">
                                      <SearchBar
                                        {...toolkitprops.searchProps}
                                        onChange={e => {
                                          toolkitprops.searchProps.onChange(e);
                                          this.handleSearchChange();
                                        }}
                                      />
                                      <i className="bx bx-search-alt search-icon" />
                                    </div>
                                  </div>
                                </Col>
                                <Col sm="8">
                                  <div className="text-sm-end"></div>
                                </Col>
                              </Row>
                              <Row>
                                <Col xl="12">
                                  <div className="table-responsive">
                                    <BootstrapTable
                                      {...toolkitprops.baseProps}
                                      {...paginationTableProps}
                                      defaultSorted={defaultSorted}
                                      classes={
                                        'table align-middle table-nowrap table-hover'
                                      }
                                      bordered={false}
                                      striped={false}
                                      responsive
                                      ref={this.node}
                                    />
                                  </div>
                                </Col>
                              </Row>
                              <Row className="align-items-md-center mt-30">
                                <Col className="pagination pagination-rounded justify-content-end mb-2">
                                  <PaginationListStandalone
                                    {...paginationProps}
                                  />
                                </Col>
                              </Row>
                            </React.Fragment>
                          )}
                        </ToolkitProvider>
                      )}
                    </PaginationProvider>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  listResult: safeGet(state, ['linking', 'list'], {}),
  unLinkResult: safeGet(state, ['linking', 'unbind_merchat_id']),
});

const mapDispatchToProps = dispatch => ({
  List: () => dispatch(list()),
  UnlinkMerchant: payload => dispatch(unbind_merchat_id(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ListLinking);
